import React, { useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { convertDateFromServer } from 'app/shared/util/date-utils';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CaseTabContext } from 'app/edozvola/cases/case-form-wrapper';
import ManagableTable from 'app/shared/view-table/managable-table';
import { changeActActivityQuery, fetchCaseActsQuery } from 'app/edozvola/cases/case-acts/service/case-acts.queries';
import { openFileInNewTab } from 'app/shared/util/file-utils';
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';
import { getCaseActFile } from 'app/edozvola/cases/service/cases.service';
import { CaseActModel } from '../cases.model';
import { ENTITY_TYPE } from 'app/shared/digital-signature/digital-signature.model';
import { useDigitalSignatureModal } from 'app/shared/digital-signature/DigitalSignatureModalContext';
import error = toast.error;
import { ActValidationErrorModel } from 'app/shared/reducers/validationerrors/model/validation-errors.model';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';
import { getInvalidCaseActs } from 'app/shared/util/validation-errors.util';
import { openFileInNewWindow } from 'app/shared/util/navigation-util';

export interface ICaseActProps {
  onRowClick: (string, boolean) => void;
  tableMessage?: string;
}

const CaseActsTable = (props: ICaseActProps) => {
  const { id: uuid } = useParams<{ id: string }>();
  const { sidebarItemPair } = useContext(CaseTabContext);
  const { openDigitalSignatureModal } = useDigitalSignatureModal();

  const { mutate: changeActivityMutation, isPending } = changeActActivityQuery(uuid);

  const downloadFile = (caseAct: CaseActModel) => {
    getCaseActFile(caseAct.idCaseAct)
      .then(data => {
        if (data) {

          openFileInNewWindow(data.url);
        }
      })
      .catch(err => showToast(error, 'Dogodila se greška prilikom preuzimanja dokumenta.'));
  };

  const openDigitalSignature = (value: CaseActModel) => {
    openDigitalSignatureModal({ entity: ENTITY_TYPE.CASE_ACT, idEntity: value.idCaseAct });
  };

  const invalidCaseActs: ActValidationErrorModel[] = getInvalidCaseActs();
  const invalidCaseActIds = invalidCaseActs.map(act => act.nonValidActRowId);

  const getErrorsForInvalidCaseAct = (idCaseAct: number) => {
    return invalidCaseActs.filter(act => act.nonValidActRowId === idCaseAct).map(act => act.errorMessage);
  };


  const renderCaseActTableRow = (value: CaseActModel, caseIndex: number, setFieldValue) => {
    return (
      <tr key={caseIndex}>
        {invalidCaseActIds.length > 0 && (
          <td>
            {invalidCaseActIds.includes(value.idCaseAct) && value.active && (
              <div className={'actions-container d-flex justify-content-center'}>
                <TooltipWrapper message={getErrorsForInvalidCaseAct(value.idCaseAct)}>
                  <FontAwesomeIcon className={'act-error-icon'} icon={'triangle-exclamation'} />
                </TooltipWrapper>
              </div>
            )}
          </td>
        )}
        <td className="break-words-column">{value.name}</td>
        <td>{value.fileNumber}</td>
        <td className="compact-column">{convertDateFromServer(value.createdDate)}</td>
        <td>{value.lastDigitalSignatureBy}</td>
        {!sidebarItemPair?.readOnly && (
          <td>
            {value.canUserSeeActDocument && (
              <div className={'actions-container'}>
                <FontAwesomeIcon icon={'file'} className={'icon-table'} onClick={() => downloadFile(value)} />
                {!sidebarItemPair?.readOnly && value.canSignAct && (
                  <FontAwesomeIcon icon={'pencil'} className={'icon-table'} onClick={() => openDigitalSignature(value)} />
                )}
              </div>
            )}
          </td>
        )}
      </tr>
    );
  };

  return (
    <>
      <ManagableTable
        autoLayout
        initialPaginationColumn={'name'}
        renderTableRow={renderCaseActTableRow}
        fetchDataQuery={fetchCaseActsQuery}
        fetchDataProps={uuid}
        noDataMessage={props.tableMessage ?? 'Dokument zahtjeva nije izrađen.'}
      >
        {invalidCaseActIds.length > 0 && <ViewTableHeaderColumn renderSort={false} columnLabels={[]} />}
        <ViewTableHeaderColumn renderSort sortKey={'name'} columnLabels={['Naziv akta']} />
        <ViewTableHeaderColumn renderSort sortKey={'fileNumber'} columnLabels={['Urudžbeni broj']} />
        <ViewTableHeaderColumn compactColumn renderSort sortKey={'createdDate'} columnLabels={['Datum urudžbiranja']} />
        <ViewTableHeaderColumn renderSort sortKey={'lastDigitalSignatureBy'} columnLabels={['Zadnji validni potpis']} />
        {!sidebarItemPair?.readOnly && <ViewTableHeaderColumn renderSort={false} columnLabels={['Akcije']} width={'135px'} />}
      </ManagableTable>
    </>
  );
};

export default CaseActsTable;
